export const CONFIRM_BOOKING_URL = `/corporate/labs/booking`

export const commonError = {
    image: {
        src: "https://onemg.gumlet.io/staging/2b134763-ca66-4c34-b8e0-9ad39a1a6022.svg",
        alt: "No Test Found",
        height: 216,
        width: 216,
    },
    header: "Uh oh!",
    subheader:
        "Failed to fetch booking details. Kindly refresh or write to us at <strong>tcs@1mg.com</strong> if the issue persists.",
}
